import { SxProps } from '@mui/material';
import { Fonts } from 'common-types';

export const headerSx: SxProps = {
  position: 'fixed',
  top: 32,
  left: '50%',
  transform: 'translateX(-50%)',
  maxWidth: 1232,
  width: 'calc(100% - 40px)',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: 10,
  transition: 'transform 0.3s ease-in-out',
  '.navbar-hidden &': {
    transform: 'translateX(-50%) translateY(-150%)',
  },
};

export const headerLogoContainerSx: SxProps = {
  alignItems: 'center',
  transition: 'opacity 0.2s ease',
  '&:hover, &:focus-visible': {
    opacity: 0.8,
  },
};

export const navLinksContainerSx: SxProps = {
  gap: 10,
  borderRadius: 10,
  boxShadow: '0px 0px 20px 0px rgba(131,131,131,0.1)',
  height: 72,
  backgroundColor: 'common.white',
  px: 10,
  py: 4,
};

export const navLinkSx = (isActive: boolean): SxProps => ({
  textDecoration: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  pb: '5px',
  pointerEvents: isActive ? 'none' : 'auto',
  '&:hover > :last-child': {
    transform: 'translateX(-50%) scaleX(1)',
  },
});

export const navLinkTextSx: SxProps = {
  fontFamily: `${Fonts.ABC_ORACLE}, sans-serif`,
  fontWeight: 500,
  fontSize: 15,
  lineHeight: 1.46,
  color: '#0f0f0f',
};

export const navIndicatorSx = (isActive: boolean): SxProps => ({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  width: 24,
  height: 3,
  borderRadius: 1,
  backgroundColor: '#0f0f0f',
  transform: isActive ? 'translateX(-50%) scaleX(0.6)' : 'translateX(-50%) scaleX(0)',
  transformOrigin: 'center',
  transition: 'transform 0.3s ease',
});

export const avatarLinkContainerSx: SxProps = {
  position: 'relative',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  width: 44,
  height: 44,
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(0deg, #C1FD79 0.18%, #FFFC7C 127.49%)',
    zIndex: -1,
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  '&:hover, &:focus-visible': {
    '&::after': {
      opacity: 1,
    },
  },
};

export const avatarSx: SxProps = {
  width: 40,
  height: 40,
  borderRadius: '50%',
  objectFit: 'cover',
  bgcolor: '#E8E8E8',
};
